import { Outlet } from "react-router";

import Backdrop from "./Backdrop";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import SchoolSidebar from "./SchoolSidebar";
import { RootState, useAppSelector } from "../redux/store";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const { user } = useAppSelector((state: RootState) => state.auth);

  return (
    <div className="min-h-screen xl:flex">
      <div>
        {user?.role === "school-admin" ? <SchoolSidebar /> : <AppSidebar />}
        <Backdrop />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <AppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
